import React from 'react';
import SubHeader from '../components/Subheader/Subheader';
import JobListAccordionComp from "../components/JobListAccordion";
import {Accordianlist} from "../components/JobListAccordion/Accordianlist"
import { ServiceOptions } from "../components/Subheader/data.js";

import {
  TextField,
  Grid,

  InputAdornment,
  Icon,
} from "@mui/material";


const Service = () => {

    return (
        <Grid>
           <SubHeader name="Service Providers" options={ServiceOptions}/>
           <Grid style={{

            display:'flex',
           
          marginTop:'22px',
           
           }}>
<Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',whiteSpace:'nowrap',width:'20%',}}>User Name</Grid>
  <Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',marginLeft:'20%'}}>Profile status</Grid>
  <Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',marginLeft:'28%'}}>Email</Grid>

           </Grid>
           <JobListAccordionComp
        Accordianlist={Accordianlist}
        //JobStatus={status}  
        Pagename={'service'}      
      ></JobListAccordionComp >
        </Grid>
    );
}

export default Service;